import { NavLink } from "react-router-dom";

export function SectionPricing1Inner() {
  return (
    <>
      <div className="container">
        <div className="section-head center">
          <div className="sx-head-s-title">Service Engagement</div>
          <div className="sx-head-l-title"><h2 className="sx-title">Flexible Security Deployment Models</h2></div>
        </div>
        <div className="section-content">
          <div className="sx-p-table-section">
            <div className="sx-p-table-bx-1 wow fadeInDown t-r-first" data-wow-duration="1000ms">
              <div className="sx-p-table-bx-1-top"><h3 className="sx-title">Engagement Highlights</h3></div>
              <div className="sx-p-table-bx-1-mid"><ul><li>Close protection and VIP security</li><li>Technical and protective surveillance</li><li>Travel and movement management</li><li>HEAT and MRE training capability</li><li>Community and stakeholder engagement</li><li>24/7 operational support</li></ul></div>
              <div className="sx-p-table-bx-1-bottom" />
            </div>
            {["Operational Support","Project Security","Executive Protection","Specialized Training"].map((plan, i) => (
              <div key={plan} className={`sx-p-table-bx-2 wow fadeInDown t-r-${i + 2}`} data-wow-duration="1000ms">
                <div className="sx-p-table-bx-2-top-title"><span>{plan}</span></div>
                <div className="sx-p-table-bx-2-top"><h3 className="sx-price">Custom<span>/scope</span></h3></div>
                <div className="sx-p-table-bx-2-mid"><ul><li><div className="sx-plan-enable"><i className="feather-check" /></div><span>Service scoped to risk profile</span></li><li><div className="sx-plan-enable"><i className="feather-check" /></div><span>Dedicated specialist team</span></li><li><div className="sx-plan-enable"><i className="feather-check" /></div><span>Field reporting and oversight</span></li><li><div className="sx-plan-enable"><i className="feather-check" /></div><span>Transparent compliance process</span></li><li><div className="sx-plan-enable"><i className="feather-check" /></div><span>Responsive escalation support</span></li><li><div className="sx-plan-enable"><i className="feather-check" /></div><span>Regional operational reach</span></li></ul></div>
                <div className="sx-p-table-bx-2-bottom"><NavLink to="/contact-us" title="READ MORE" rel="bookmark" className="site-button icon"><i className="fa fa-long-arrow-right" />Request Engagement</NavLink></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

function SectionPricing1() {
  return (
    <>
      <div className="section-full p-t110 p-b110 sx-p-table-outer sx-bg-white wow fadeInDown" data-wow-duration="1000ms"><SectionPricing1Inner /></div>
    </>
  );
}

export default SectionPricing1;
